import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { ResultadosService } from '../../resultados.service';
import { AuthService } from 'app/auth/auth.service';

import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
@Component({
  selector: 'app-tableau',
  templateUrl: './tableau.component.html',
  styleUrls: ['./tableau.component.scss'],
  animations : fuseAnimations
})
export class TableauComponent implements OnInit {

  cargando = true;
  origen: string;
  nivelUsuario: number;
  idInstituto: string;

  urlTableau = DATOS_API.urlTableau;
  tokenTableau: string;

  //variablesTableau
  ctoken: string;
  user: string;
  ulvl: number;
  broker: number;
  langCode: number;

  tableauVersion: string;
  versionSuccesGo:any;
  urlSafe: any;

  constructor(
    private activatedRoute:ActivatedRoute,
    private router:Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private servTableau: ResultadosService,
    private resultranslateSrv: TranslateService,
    private authService: AuthService,
    public sanitizer: DomSanitizer
  )
  {
    console.log(this.router.getCurrentNavigation().extras.state);

      if(this.router.getCurrentNavigation().extras.state){
        this.tableauVersion = this.router.getCurrentNavigation().extras.state.tableauVersion;
        console.log("version tableau obtenida");
        console.log(this.tableauVersion);
      }else{
        console.log("version NONONO tableau obtenida");
      }

      this.resultranslateSrv.onLangChange.subscribe(() => {
        console.log('La mando a llamar otra vez y  otra vez');
        if (localStorage.getItem('productoID') && localStorage.getItem('resultOk')) {
          console.log('Si existe por que entro desde resultados');
            this.enviaFormulario();
        }
      });

      lang_resultados.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      lang_perfiles.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      lang_idiomas.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      lang_cierre.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      //remueve la etiqueta https
      // if(window.location.protocol != 'https:'){
      //   document.querySelector("[http-equiv='Content-Security-Policy']").remove();
      // }
  }

  ngOnInit() {
    console.log("hio el intento por entrar");

    localStorage.setItem('resultOk','OK')
    this.getBanderasProducto();
    this.enviaFormulario();
  }
  globalUser:any;
  globalLevel:any;
  enviaFormulario(){
    this.idInstituto = this.authService.getInstituto();
    let datosUsu = this.authService.getInfoUsuario();
    let idUsuario:any='';
    let bandera=0;
    console.log(datosUsu);
    this.globalUser=datosUsu.user;
    this.globalLevel=datosUsu.level;
    /*if(datosUsu.level != 1){
      bandera=1;
      this.continuacion(datosUsu,bandera,idUsuario);
      this.servTableau.getUsuariosEmpresas(datosUsu.empresaId,this.idInstituto).subscribe((response:any) => {
        if(response.success){
         let aux_array:[]=[];
         console.log(response);
         aux_array=response.usuarios;
         for(let i=0; i < response.usuarios.length; i++){
            if(response.usuarios[i].level == 1){
              idUsuario=response.usuarios[i]._id;
              console.log("Usuario nuevo "+idUsuario);
              break;
            }
         }
         console.log(datosUsu);
         this.continuacion(datosUsu,bandera,idUsuario);
        }

       }, error => {
         console.log(error);
       });
    }else{
      this.continuacion(datosUsu,bandera,idUsuario);
    }*/
// if (localStorage.getItem('tipoMedir')=="2") {
//   console.log('entro con producto medir');
//
//   this.continuacion(datosUsu,bandera,idUsuario);
// }else{
  console.log('entro con producto diferente');
  this.newGetUrlResults(bandera,idUsuario);

// }

  }

newGetUrlResults(bandera,idUsuario){
  let claveIdioma =this.resultranslateSrv.currentLang;
  console.log("entro perro",claveIdioma);
  let claveIdiomaDato:any;
  switch (claveIdioma) {
    case 'es':
      claveIdiomaDato='ES';
      break;
    case 'tr':
      claveIdiomaDato='TR';
      break;
    case 'en':
      claveIdiomaDato='EN';
      break;
    case 'zh1':
      claveIdiomaDato='ZH1';
      break;
    case 'zh2':
      claveIdiomaDato='ZH2';
      break;
    case 'pt':
      claveIdiomaDato='PT';
      break;
    case 'de':
      claveIdiomaDato='DE';
      break;
    case 'nl':
      claveIdiomaDato='NL';
      break;

    default:
      break;
  }
  let datos = {productoId:localStorage.getItem('productoID')};
  let datosUsu = this.authService.getInfoUsuario();
  this.servTableau.getParamsTableau(datos,bandera,idUsuario).subscribe( (respuesta:backInter.getParamsTableau) => {
    console.log(respuesta);
    let idProducto= respuesta.productoId;
    if(respuesta.success){
      if (localStorage.getItem('instituto')=='14') {
        this.servTableau.getURLGoGCTI(datosUsu.empresaId,respuesta.surveyToken, idProducto, respuesta.brokerId, claveIdiomaDato, respuesta.user).subscribe( (respuestaUrl:any) => {
        console.log(respuestaUrl);
        if(!respuestaUrl.success){
          if (respuestaUrl.message== "TypeError: Cannot read property 'fechaLanzamiento' of undefined") {
            Swal.fire({
              title: this.resultranslateSrv.instant('MODALES.MENSAJES.NO_FECH_LAN'),
              icon: 'warning',
              confirmButtonText: this.resultranslateSrv.instant('MODALES.ACCIONES.aceptar'),
              confirmButtonColor: '#e40601'
            });
            let ruta='/results/trust_index/';
            this.router.navigate([ruta]);
          }else{
            let texto = '';
            this.resultranslateSrv.get('MODALES.ERROR_DATOS').subscribe((res: string) => { texto = res; });
            let rspSi = 'MODALES.ACCIONES.aceptar';
            this.resultranslateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
            Swal.fire({
              title: texto,
              icon: 'warning',
              confirmButtonText: rspSi,
              confirmButtonColor: '#e40601'
            });

          }

        }else{
          this.urlTableau = respuestaUrl.urlSuccesGo;
          this.cargando = false;
          setTimeout(() => {
            // console.log("se dispara form alv");
            $('#RecDatos').submit();
          },1000);
        }
      });

    }
    else{
      let flag=localStorage.getItem('versionResultSuccesGo');
        this.servTableau.getURLSuccessGoV4(datosUsu.empresaId,respuesta.surveyToken, idProducto, respuesta.brokerId, claveIdiomaDato, respuesta.user,flag,1).subscribe( (respuestaUrl:any) => {
        console.log(respuestaUrl);
        if(!respuestaUrl.success){
          if (respuestaUrl.message== "TypeError: Cannot read property 'fechaLanzamiento' of undefined") {
            Swal.fire({
              title: this.resultranslateSrv.instant('MODALES.MENSAJES.NO_FECH_LAN'),
              icon: 'warning',
              confirmButtonText: this.resultranslateSrv.instant('MODALES.ACCIONES.aceptar'),
              confirmButtonColor: '#e40601'
            });
            let ruta='/results/trust_index/';
            this.router.navigate([ruta]);
          }else{
            let etqProducto = this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.ETQ_PROD');
            let etqBroker= this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.ETQ_BROK');
            let etqPais= this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.ETQ_COUN');
            let etqIdioma=this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.ETQ_LANG');
            let etqCertificado= this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.ETQ_CERTY');
            let country:any;
            if (respuestaUrl.country==undefined) {
            country=this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.COUNTR_NO_SELEC');
          }else{
            country=respuestaUrl.country;
          }
            // this.resultranslateSrv.get('MODALES.ERROR_DATOS').subscribe((res: string) => { texto = res; });
            let rspSi = 'MODALES.ACCIONES.aceptar';
            Swal.fire({
              title: '<font color="red">'+this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.TITLE_MODA')+'</font>',
              icon: 'warning',
               width: 450,
               padding: '1em',
              html: `<span class="modal2em">
                <b>${etqBroker}</b>${respuestaUrl.broker}<br><br>
                <b>${etqProducto}</b>${respuestaUrl.product}<br><br>
                <b>${etqPais}</b>${country}<br><br>
                <b>${etqIdioma}</b>${respuestaUrl.lang}<br><br>
                <b>${etqCertificado}</b>${this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.'+respuestaUrl.certificate)}<br><br></span>`,
              confirmButtonText: this.resultranslateSrv.instant('MODALES.ACCIONES.aceptar'),
              confirmButtonColor: '#e40601'
            });
            // Con traducción
            // html: `<span class="modal2em">
            //   <b>${etqBroker}</b>${respuestaUrl.broker}<br><br>
            //   <b>${etqProducto}</b>${this.resultranslateSrv.instant('CONSULTATABLA.PRODUCTOS.'+respuestaUrl.product)}<br><br>
            //   <b>${etqPais}</b>${country}<br><br>
            //   <b>${etqIdioma}</b>${this.resultranslateSrv.instant('NOMBREIDIOMAS.'+respuestaUrl.lang.toLowerCase())}<br><br>
            //   <b>${etqCertificado}</b>${this.resultranslateSrv.instant('RESULTADOS.ETIQ_MODAL_RESULT.'+respuestaUrl.certificate)}<br><br></span>`,
          }

        }else{
          let productosModal=[40,41];
          if (respuestaUrl.modalAviso== true && localStorage.getItem("instituto")=="1" && productosModal.includes(parseInt(localStorage.getItem("tipoMedir"))) && localStorage.getItem("fechaProductorResult")=="2023"){
            Swal.fire({
              icon: 'info',
              title: respuestaUrl.message,
              width: 600,
              confirmButtonText: this.resultranslateSrv.instant('CIERRE.ALERT.OK'),
            });
          }

          /// concatenar parametro id dominio
          const paramsDominios = [
            // { dominio: 'culturalgo.com', id: '01' },
            { dominio: 'localhost', id: '01' },
            { dominio: 'app04.culturalgo.com', id: '02' }
          ];
          const [dominio] = (window.location.href).split('#');
          const urlSplit = respuestaUrl.urlSuccesGo.split('&');
          let domCoincidente: any = { dominio: 'culturalgo.com', id: '01' };
          paramsDominios.every(domEsp => {
            if(dominio.includes(domEsp.dominio)){
              domCoincidente = domEsp;
              return false;
            }
            return true;
          });
          urlSplit.push(`domain_id=${domCoincidente.id}`);
          let urlFinal = "";
          urlSplit.map(x => urlFinal = (`${urlFinal}${x}&`).trim());
          urlFinal = urlFinal.slice(0, -1);

          this.urlTableau = respuestaUrl.urlSuccesGo;
          // this.urlTableau = urlFinal;
          // console.log("URL SUCCESS GO:",this.urlTableau);
          // console.log("URL SUCCESS GO MOD:",urlFinal);

          this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.urlTableau);
          this.cargando = false;
          setTimeout(() => {
            // console.log("se dispara form alv");
            // $('#RecDatos').submit();
          },1000);
        }
      });

      }
    }
  });
}

  continuacion(datosUsu,bandera,idUsuario){
    console.log(this.idInstituto);
    console.log(datosUsu);
    console.log(this.tableauVersion);
    if(this.tableauVersion){
      console.log("Entro porque tiene tablue versión");
      switch (this.idInstituto) {
        case '5': case 'TK':
        this.urlTableau = this.urlTableau.replace("--VERSION--","Ver3.3");
        break;
        default:
        if(this.tableauVersion.includes('3.')){
          this.tableauVersion = "Ver" + this.tableauVersion;
        }
        this.urlTableau = this.urlTableau.replace("--VERSION--",this.tableauVersion);
      }
    }
    else{
      if(localStorage.getItem('tipoBroker')){
        if(localStorage.getItem('tipoBroker') == 'wqKgj6X') {
          this.urlTableau = this.urlTableau.replace("--VERSION--","8.1");
        }
      }
      else{
        console.log("No entro porque no hay versión");
        switch (this.idInstituto) {
          case '1': case 'MX': case '15': case 'ES':
          this.urlTableau = this.urlTableau.replace("--VERSION--","Ver3.2");
          break;
          case '5': case 'TK':
          this.urlTableau = this.urlTableau.replace("--VERSION--","Ver3.3");
          break;
          case '8': case 'IZZI':
          this.urlTableau = this.urlTableau.replace("--VERSION--","8.1");
          break;
          case '14': case 'GCTI':
          this.urlTableau = this.urlTableau.replace("--VERSION--","14.1");
          break;
          default:
          this.urlTableau = this.urlTableau.replace("--VERSION--","Ver3.1");
        }
      }
    }
    this.colocaIdioma();
    if(localStorage.getItem('productoID') == 'admin'){
      this.tokenTableau = '999e72f4-ba5c-4906-aea2-8532488883d4';
      this.ctoken = 'xxx';
      this.user = 'admin@itbm.mx';
      this.ulvl = 1;
      this.broker = 1;
      this.cargando = false;
      setTimeout(() => {
        $('#RecDatos').submit();
      },1000);
    }
    else{
      console.log("Entro al no admin");
      let datos = {productoId:localStorage.getItem('productoID')};
      this.servTableau.getParamsTableau(datos,bandera,idUsuario).subscribe( (respuesta:backInter.getParamsTableau) => {
        console.log(respuesta);
        if(respuesta.success){
          this.ctoken = respuesta.surveyToken;
          this.user = respuesta.user;
          this.broker = respuesta.brokerId;
          if(datosUsu.level == 5){
            this.ulvl = 4;
          }
          else{
            this.ulvl = respuesta.userType;
          }
          this.cargando = false;
          setTimeout(() => {
            // console.log("se dispara form alv");
            $('#RecDatos').submit();
          },1000);
        }
      });
    }

  }

  colocaIdioma(){
    switch(this.resultranslateSrv.currentLang){
      case 'es': this.langCode = 60; break;
      case 'tr': this.langCode = 67; break;
      default: this.langCode = 18;
    }
  }


  getBanderasProducto(){
      let datosUsu = this.authService.getInfoUsuario();
    this.servTableau.getBanderasProducto(datosUsu.empresaId, localStorage.getItem('productoID')).subscribe((respuesta:any) => {
      console.log("getBanderasProducto:==========================================",respuesta);
      if(respuesta.success){
        this.versionSuccesGo = respuesta.versionSuccesGo;
        localStorage.setItem('versionResultSuccesGo',this.versionSuccesGo.toString());

      }
    });
  }

}
